import React from 'react';

function Footer() {
  return (
    <footer className="footer-section">
      <div className="container">
        <div className="row align-items-center">
          {/* Primera columna - Logo */}
          <div className="col-lg-3 col-md-12 col-12">
            <div className="footer-logo">
              <img src={process.env.PUBLIC_URL + '/footer.png'} alt="OPR Logo" className="footer-logo-img" />
            </div>
          </div>
          
          {/* Segunda columna - Aviso de Privacidad */}
          <div className="col-lg-3 col-md-4 col-12">
            <div className="footer-section">
              <h4 className="footer-heading">AVISO DE PRIVACIDAD</h4>
              <p className="footer-text">COPYRIGHTS © 2025</p>
              <p className="footer-text">OPV ÓPTICA PARIS</p>
            </div>
          </div>
          
          {/* Tercera columna - Contacto */}
          <div className="col-lg-3 col-md-4 col-12">
            <div className="footer-section">
              <h4 className="footer-heading">CONTACTO</h4>
              <p className="footer-text"><a href='mailto:atencionalcliente@opticasparis.mx' target="_blank" rel="noopener noreferrer">atencionalcliente@opticasparis.mx</a> </p>
              <p className="footer-text"> <a href='tel:2299317929' target="_blank" rel="noopener noreferrer" >T. 229 · 931 · 7929</a></p>
              <p className="footer-text"> <a href='https://wa.me/2293569081' target="_blank" rel="noopener noreferrer">W. 229 · 356 · 9081</a></p>
            </div>
          </div>
          
          {/* Cuarta columna - Síguenos */}
          <div className="col-lg-3 col-md-4 col-12">
            <div className="footer-section">
              <h4 className="footer-heading">SÍGUENOS</h4>
              <p className="footer-text"><a href="https://www.facebook.com/opticasparisver?locale=es_LA" target="_blank" rel="noopener noreferrer">FACEBOOK</a></p>
              <p className="footer-text"><a href="https://www.instagram.com/opticasparisver/" target="_blank" rel="noopener noreferrer">INSTAGRAM</a></p>
              <p className="footer-text"><a href="https://www.youtube.com/@OPV%C3%93pticaParis" target="_blank" rel="noopener noreferrer">YOUTUBE</a></p>
               <p className="footer-text"><a href="https://www.tiktok.com/@opticasparisver?_t=ZN-8z2HG1gzDuw&_r=1" target="_blank" rel="noopener noreferrer">TIKTOK</a></p>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}

export default Footer; 